import React, { useEffect, useRef, useState } from 'react';
import { ExternalLink, LogIn, Moon, Sun } from 'lucide-react';
import { useStore } from '../store/useStore';
import { CORREO_URL, entrarYVolverAMeet } from '../lib/dominios';
import { colorDe, iniciales } from './lib';

/** «Orvian Meet»: la marca de la empresa (hexágonos) + el nombre del producto. */
export function Marca({ oscuro = false, compacta = false }) {
  return (
    <a href="/" className={`mt-marca ${oscuro ? 'is-oscuro' : ''}`} aria-label="Orvian Meet, inicio">
      <img src="/brand/mark-light.png" alt="" className={oscuro ? 'hidden' : 'mt-marca-ico dark:hidden'} />
      <img src="/brand/mark-dark.png" alt="" className={oscuro ? 'mt-marca-ico' : 'mt-marca-ico hidden dark:block'} />
      {!compacta && (
        <span className="mt-marca-texto">
          Orvian <b>Meet</b>
        </span>
      )}
    </a>
  );
}

/** Círculo con las iniciales (o la foto si la cuenta tiene). */
export function Avatar({ nombre, clave, foto, tam = 36, className = '' }) {
  const [fallo, setFallo] = useState(false);
  const estilo = { width: tam, height: tam, fontSize: Math.round(tam * 0.4), background: colorDe(clave || nombre) };
  if (foto && !fallo) {
    return <img src={foto} alt="" className={`mt-avatar ${className}`} style={estilo} onError={() => setFallo(true)} />;
  }
  return <span className={`mt-avatar ${className}`} style={estilo} aria-hidden="true">{iniciales(nombre)}</span>;
}

export function BotonTema() {
  const theme = useStore((s) => s.theme);
  const setTheme = useStore((s) => s.setTheme);
  const oscuro = theme === 'dark';
  return (
    <button
      type="button"
      className="mt-icono-btn"
      onClick={() => setTheme(oscuro ? 'light' : 'dark')}
      title={oscuro ? 'Tema claro' : 'Tema oscuro'}
      aria-label={oscuro ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      data-testid="meet-tema"
    >
      {oscuro ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
}

/** Avatar de la cuenta con su menú, o «Iniciar sesión» (lleva al acceso del correo y vuelve aquí). */
export function Cuenta({ ruta }) {
  const user = useStore((s) => s.user);
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!abierto) return undefined;
    const fuera = (e) => { if (!ref.current?.contains(e.target)) setAbierto(false); };
    const esc = (e) => { if (e.key === 'Escape') setAbierto(false); };
    document.addEventListener('pointerdown', fuera);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('pointerdown', fuera); document.removeEventListener('keydown', esc); };
  }, [abierto]);

  if (!user) {
    return (
      <button type="button" className="mt-btn mt-btn--primario mt-btn--chico" onClick={() => entrarYVolverAMeet(ruta)} data-testid="meet-iniciar-sesion">
        <LogIn size={16} /> Iniciar sesión
      </button>
    );
  }
  const nombre = user.name || user.email;
  return (
    <div className="mt-cuenta" ref={ref}>
      <button type="button" className="mt-cuenta-btn" onClick={() => setAbierto((v) => !v)} aria-haspopup="menu" aria-expanded={abierto} title={`${nombre}\n${user.email || ''}`} data-testid="meet-cuenta">
        <Avatar nombre={nombre} clave={user.email} foto={user.avatar_url || user.foto} tam={34} />
      </button>
      {abierto && (
        <div className="mt-menu mt-menu--derecha" role="menu">
          <div className="mt-cuenta-ficha">
            <Avatar nombre={nombre} clave={user.email} foto={user.avatar_url || user.foto} tam={44} />
            <div className="min-w-0">
              <div className="mt-cuenta-nombre">{nombre}</div>
              <div className="mt-cuenta-correo">{user.email}</div>
            </div>
          </div>
          <a className="mt-menu-item" role="menuitem" href={`${CORREO_URL}/mail`} target="_blank" rel="noopener noreferrer">
            <ExternalLink size={18} /> Abrir el correo
          </a>
        </div>
      )}
    </div>
  );
}
